import React, { useEffect, useState } from 'react';
import styled, { keyframes } from 'styled-components';
import DragDrop from "./drag-drop/DragDrop"
import PlanillaCard from "./PlanillaCard"
import axios from 'axios';
import { BaseUrl } from "../../config"
import Swal from "sweetalert2";

const ModalLoadFile = ({
  onClose,
  stopPropagation,
  files,
  setFiles,
  setPrefenrencias
}) => {
  const handleCancelar = () => {
    setFiles([])
    setPrefenrencias(true)
    onClose();
  };
  const [loading, setLoading] = useState(false);
  const handleSubmit = async (event, sucursal) => {
    event.preventDefault();
    setLoading(true);
    try {
      const formData = new FormData();
      formData.append('file', files[0]);
      formData.append('sucursal', sucursal);
      const response = await axios.post(`${BaseUrl}/contact/generateContacts`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });

      setLoading(false);
      handleCancelar()
      Swal.fire({
        icon: "success",
        title: "Listado cargado con exito",
        confirmButtonText: "Listo",
        confirmButtonColor: "#003049",
        customClass: {
          title: 'my-custom-title-class'
        }
      });
    } catch (error) {
      setLoading(false);
      Swal.fire({
        icon: "error",
        title: "Ocurrio un error.",
        confirmButtonText: "Listo",
        confirmButtonColor: "#003049",
        customClass: {
          title: 'my-custom-title-class'
        }
      });
    }
  };
  const editLoding = (value) => {
    setLoading(value);
  }

  return (
    <ModalWrapper onClick={handleCancelar}>
      <ModalContent onClick={stopPropagation}>
        {
          files.length > 0  ?
           <>
             {
           loading === true ?
            <Text1>Subiendo el listado..</Text1> : <Text1>Elegí una opción</Text1>
        }
           </>  : <Text1>Cargar nueva lista</Text1>
        }
        {
          files.length > 0 ?
            null :
            <DragDrop
              files={files}
              setFiles={setFiles}
              setLoading={editLoding}
            />
        }
        {
          files.length ?
            <ContentLoadFile>
              {
                loading ?
                  <>
                    <Text2>
                      CARGANDO
                    </Text2>

                    <LoadingBar /></>

                  :
                  <>
                    {files.map((planilla, index) => (
                      <PlanillaCard
                        key={index}
                        selectPlanilla={planilla}
                        planilla={planilla}
                      />
                    ))}
                  </>

              }
            </ContentLoadFile>
            : null
        }
        {
          files.length && loading === false ?
            <ContentBtnLoadFile>
              <ButtonCustom onClick={(e) => handleSubmit(e, "La Plata")}>
                SUBIR EN LA PLATA
              </ButtonCustom>
              <ButtonCustom onClick={(e) => handleSubmit(e, "Mendoza")}>
                SUBIR EN MENDOZA
              </ButtonCustom>
            </ContentBtnLoadFile>
            : null
        }
      </ModalContent>
    </ModalWrapper>
  )
}
export default ModalLoadFile;

const ContentBtnLoadFile = styled.div`
  width: -webkit-fill-available;
  display:flex;
  flex-direction:column;
  align-items:center;
  justify-content:center;
  gap:10px
`;

const ButtonCustom = styled.div`
  width: -webkit-fill-available;
  height: 50px;
  min-height:50px;
  border:solid 2px #003049;
  border-radius:12px;
  display:flex;
  flex-direction:column;
  align-items:center;
  justify-content:center;
  font-family: 'Montserrat', sans-serif;
  font-weight: 800;
  font-size: 16px;
  color: #003049;
  cursor:pointer;
  &:hover{
    background-color:#003049;
    color:#FFFFFF;
  }
`;

const Text1 = styled.span`
  width: -webkit-fill-available;
  font-family: 'Montserrat', sans-serif;
  font-weight: 800;
  font-size: 25px;
  color: #003049;
  line-height:auto;
  text-align: center;
`;
const ContentLoadFile = styled.div`
width:-webkit-fill-available;
height:auto;
display:flex;
flex-direction:column;
gap:3px;
`

const loadingAnimation = keyframes`
  0% { width: 0; }
  100% { width: 100%; }
`;

const LoadingBar = styled.div`
  width: 100%;
  height: 2px;
  background-color: #ccc; /* Color de fondo */
  border-radius: 10px;
  overflow: hidden;
  &::after {
    content: '';
    display: block;
    height: 100%;
    width: 0;
    background-color: #1a455b; /* Color de la barra de carga */
    animation: ${loadingAnimation} 2s ease-in-out infinite; /* La animación dura 2 segundos */
  }
`;

const Text2 = styled.span`
  width: -webkit-fill-available;
  font-family: 'Montserrat', sans-serif;
  font-weight: 600;
  font-size: 12px;
  color: #334443;
  leter-spacing:2%;
  line-height:18px
`;

const ModalContent = styled.div`
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.1);
  padding: 48px;
  width: -webkit-fill-available;
  max-width:400px;
  padding: 20px auto;
  font-family: 'Montserrat', sans-serif;
  font-weight: 500;
  font-size: 14px;
  max-height:80vh;
  overflow-y: auto;
  display:flex;
  flex-direction: column;
  align-items: flex-start;
  gap:36px;
  &::-webkit-scrollbar {
    height: 4px;
    width: 3px;
    background-color: transparent !important;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }
  
  &::-webkit-scrollbar-thumb {
    background-color: #003049 !important;
    border-radius: 8px;
  }
`;

const ModalWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;